import { render, staticRenderFns } from "./btn-secondary2.vue?vue&type=template&id=542e2f5b&scoped=true&"
import script from "./btn-secondary2.vue?vue&type=script&lang=js&"
export * from "./btn-secondary2.vue?vue&type=script&lang=js&"
import style0 from "./btn-secondary2.vue?vue&type=style&index=0&id=542e2f5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542e2f5b",
  null
  
)

export default component.exports